import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
	static get targets () {
		return ['phoneInput', 'otpInput', 'submit'];
	}

	connect() {
		this._lang = document.documentElement.lang.split('-')[0];
	}

	submitTargetConnected(element) {
		element.addEventListener('click', async () => {
			if (!this.hasPhoneInputTarget) {
				return;
			}

			await this.sendOtp(this.phoneInputTarget.value);
		});
	}

	async sendOtp(phone) {
		const url = klark.api + 'otp/send?rest_language=' + this._lang;

		let response;
		this.submitTarget.classList.add('loading');

		try {
			this.element.querySelectorAll('span.input-error').forEach(err => err.remove());
			response = await this.handlePostSubmit(url, {
				phone: phone
			});

			response = response.data.data;
		} catch (error) {
			response = error.response.data.data;
		}

		this.otpInputTarget.disabled = false;
		this.otpInputTarget.focus();

		if (response.error) {
			const messageNode = document.createElement('span');
			messageNode.classList.add('input-error');
			messageNode.innerHTML = response.error;
			this.phoneInputTarget.parentNode.insertBefore(messageNode, this.phoneInputTarget.nextSibling);
		}

		if (response?.resend) {
			this._startResendCountdown();
		}

		this.submitTarget.classList.remove('loading');
	}

	_startResendCountdown() {
		const originalText  = this.submitTarget.textContent;
		const resendText    = this.submitTarget.dataset.resendText;
		let seconds         = parseInt(this.submitTarget.dataset.resendSeconds);
		this.submitTarget.classList.add('btn-light');
		this.submitTarget.classList.remove('btn-primary');

		this.submitTarget.disabled     = true;
		this.submitTarget.textContent  = resendText.replace('%s', seconds + 's');

		const interval = setInterval(() => {
			seconds--;
			this.submitTarget.textContent = resendText.replace('%s', seconds + 's');

			if (seconds <= 0) {
				clearInterval(interval);
				this.submitTarget.disabled    = false;
				this.submitTarget.textContent = originalText;
				this.submitTarget.classList.remove('btn-light');
				this.submitTarget.classList.add('btn-primary');
			}
		}, 1000);
	}

	handlePostSubmit(url, data, config) {
		if (window.grecaptcha) {
			return new Promise((resolve) => {
				window.grecaptcha.ready(() => {
					resolve(window.grecaptcha.execute(document.querySelector('meta[name="global_recaptcha_site_key"]').content, { action: 'submit' }));
				});
			}).then(recaptchaToken => {
				data.recaptcha = recaptchaToken;

				return Axios.post(url, data, config);
			});
		}

		return Axios.post(url, data, config);
	}
}
